var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.98438 8.43576C2.98438 4.05296 6.53733 0.5 10.9201 0.5C15.3029 0.5 18.8559 4.05296 18.8559 8.43576V19.587H2.98438V8.43576Z",
    fill: "#191819"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99831 17.2466H18.8547L22.4951 22.4155H0L2.99831 17.2466Z",
    fill: "#191819"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellicon);
export default __webpack_public_path__ + "static/media/bellicon.61a3c708b6ee95b2b8c567bd195117ce.svg";
export { ForwardRef as ReactComponent };